/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import FactoryRounded from '@mui/icons-material/FactoryRounded';
import LocalOfferRounded from '@mui/icons-material/LocalOfferRounded';
import { Tooltip } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { formatDate, type ScenarioProjectColumn } from '@poweralpha/common';
import { InfoPill } from '../text';

interface Props {
  runName: string | undefined | null;
  stage: ScenarioProjectColumn['stage'] | null;
  hideTimestamp?: boolean;
  iconsOnly?: boolean;
  rightAligned?: boolean;
}

function ScenarioName({ stage, runName, hideTimestamp, iconsOnly, rightAligned }: Readonly<Props>) {
  return (
    <Stack
      direction={rightAligned ? 'row-reverse' : 'row'}
      spacing={1}
      sx={{
        alignItems: 'center',
      }}
    >
      {stage && (
        <Box>Basis of Design {!hideTimestamp && formatDate(stage.timestamp, 'YYYY-MM-DD')}</Box>
      )}
      {!stage && <Box>{runName}</Box>}
      {stage?.por_design &&
        (iconsOnly ? (
          <Tooltip title="POR Design">
            <LocalOfferRounded color="info" sx={{ height: 15, width: 15 }} />
          </Tooltip>
        ) : (
          <InfoPill
            label="POR Design"
            icon={<LocalOfferRounded color="info" sx={{ height: 15, width: 15 }} />}
            color="info"
          />
        ))}
      {stage?.as_built_design &&
        (iconsOnly ? (
          <Tooltip title="As-Built Design">
            <FactoryRounded color="success" sx={{ height: 15, width: 15 }} />
          </Tooltip>
        ) : (
          <InfoPill
            label="As-Built Design"
            icon={<FactoryRounded color="success" sx={{ height: 15, width: 15 }} />}
            color="success"
          />
        ))}
    </Stack>
  );
}

export default ScenarioName;
